<div class="container-fluid">
  <app-custom-table-title [icon]="icon" [title]="title" [subTitle]="subTitle"></app-custom-table-title>
  <div class="mt-4 mb-4 cf-table-card">

    <ng-template #ownFinancingSummary let-data="data">
      <div class="total-card">
        <p class="label">Inicial: <strong>{{ totals.initial | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="total-card">
        <p class="label">Pendiente: <strong>{{ totals.pending | number:'1.2-2' }} €</strong></p>
      </div>
    </ng-template>

    <ng-template #quickFilter>
      <div class="quick-filter">
        <app-search-filter [value]="quickSearch" (searchChange)="onSearchChange($event)"></app-search-filter>
      </div>
    </ng-template>

    <app-custom-table #table="customTable" [config]="tableConfig"></app-custom-table>

    <ng-template #expandDetail let-row>
      <app-financing-detail-panel [row]="row" [loader]="detailLoader" [deleter]="detailDeleter" (action)="onDetailAction(row, $event)"></app-financing-detail-panel>
    </ng-template>
  </div>
</div>
